// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__t60Tc","flexBox":"footer_flexBox__W-SN7","flexItem":"footer_flexItem__M+Yf5"};